import { AuditAction } from '@core/enum/auditAction';
import type { AuditLogRenderer } from '@core/utils/auditLog';
import { renderEntityCreated } from './renderers/entityCreated';
import { renderEntityDeleted } from './renderers/entityDeleted';
import { renderEntityDuplicated } from './renderers/entityDuplicated';
import { renderEntityUpdated } from './renderers/entityUpdated';
import { renderJobOrderPrinted } from './renderers/jobOrderPrinted';
import { renderOrderStatusChanged } from './renderers/orderStatusChanged';
import { renderProductionStageChanged } from './renderers/productionStageChanged';

export const LEITOURGOS_AUDIT_LOG_RENDERERS: Partial<
  Record<AuditAction, AuditLogRenderer>
> = {
  [AuditAction.EntityCreated]: renderEntityCreated,
  [AuditAction.EntityUpdated]: renderEntityUpdated,
  [AuditAction.EntityDeleted]: renderEntityDeleted,
  [AuditAction.EntityDuplicated]: renderEntityDuplicated,
  [AuditAction.OrderStatusChanged]: renderOrderStatusChanged,
  [AuditAction.ProductionStageChanged]: renderProductionStageChanged,
  [AuditAction.JobOrderPrinted]: renderJobOrderPrinted,
};
